import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import { C } from "./ipd-billing/constants";
import SvgIcon from "./ipd-billing/SvgIcon";
import CorporateRateCardList from "./ipd-billing/components/CorporateRateCardList";
import CorporateRateCardEditor from "./ipd-billing/components/CorporateRateCardEditor";

// ─────────────────────────────────────────────────────────────────────────────
// Corporate Rate Card admin (manager landing tile → /corporate-rate-card)
//
// Two internal views:
//   list   — corporate payers + rate cards (create / edit / suspend)
//   editor — one rate card header + line items (manual grid + CSV upload)
// Rendered inside IPDBillingAppShell (app navbar + background + permissions).
// ─────────────────────────────────────────────────────────────────────────────
export default function CorporateRateCard() {
  const history = useHistory();
  // view = { name: "list" } | { name: "editor", rateCardId, payer }
  const [view, setView] = useState({ name: "list" });

  const openEditor = (rateCardId = null, payer = null) =>
    setView({ name: "editor", rateCardId, payer });
  const backToList = () => setView({ name: "list" });

  return (
    <div style={{ minHeight: "calc(100vh - 140px)", background: C.bg }}>
      <style>{`
        @keyframes ipdFadeIn { from { opacity: 0; transform: translateY(4px); } to { opacity: 1; transform: none; } }
        @keyframes ipdShimmer { 0% { background-position: 200% 0; } 100% { background-position: -200% 0; } }
        .crc-btn { transition: background 0.12s, box-shadow 0.12s; }
      `}</style>

      {/* Header */}
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: "14px",
          padding: "18px 32px",
          background: C.card,
          borderBottom: `1px solid ${C.border}`,
        }}
      >
        <button
          onClick={() => (view.name === "editor" ? backToList() : history.push("/main-landing"))}
          className="crc-btn"
          style={{
            display: "flex",
            alignItems: "center",
            gap: "6px",
            padding: "7px 12px",
            background: "#fff",
            border: `1px solid ${C.border}`,
            borderRadius: "8px",
            color: C.text,
            fontSize: "13px",
            fontWeight: 600,
            cursor: "pointer",
          }}
        >
          <SvgIcon name="back" size={16} color={C.text} />
          {view.name === "editor" ? "Rate cards" : "Home"}
        </button>

        <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
          <div
            style={{
              width: "34px",
              height: "34px",
              borderRadius: "9px",
              background: C.primary,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <SvgIcon name="percent" size={18} color="#fff" />
          </div>
          <div>
            <div style={{ fontSize: "17px", fontWeight: 800, color: C.text }}>
              Corporate Rate Cards
            </div>
            <div style={{ fontSize: "11px", color: C.textSub, fontWeight: 600 }}>
              Contracted corporate pricing · tenant-wide setup
            </div>
          </div>
        </div>
      </div>

      <div style={{ padding: "24px 32px" }}>
        {view.name === "list" ? (
          <CorporateRateCardList onOpenEditor={openEditor} />
        ) : (
          <CorporateRateCardEditor
            rateCardId={view.rateCardId}
            initialPayer={view.payer}
            onBack={backToList}
            onSaved={openEditor}
          />
        )}
      </div>
    </div>
  );
}
